<template>
  <div>
    <div style="clear: both; margin-bottom: 5px; display: block;padding-right:unset!important;">
      <div style="float: right; margin-left: 2px; z-index: 0;padding-right:unset!important;">
        <button
            v-if="!commonModule.centralInstance"
            type="submit"
            id="refresh-order-details-btn"
            @click="resetOrderDetails()"
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
        >
          <i class="bx bx-reset align-middle font-size-16"/>
          Resetuj zamówienie
        </button>
      </div>
      <div style="float: right; margin-left: 2px; z-index: 0;padding-right:unset!important;">
        <button
            v-if="!commonModule.centralInstance"
            type="submit"
            id="check-order-btn"
            @click="checkOrderSupplies()"
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
        >
          <i class="bx bx-list-check align-middle font-size-16"/>
          Sprawdź dostawy
        </button>
      </div>
      <div style="float: right; margin-left: 2px; z-index: 0;padding-right:unset!important;">
        <button
            v-if="!commonModule.centralInstance"
            type="submit"
            id="open-order-file-btn"
            @click="openOrderExcelFile()"
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
            :disabled="currentOrder.orderExcelFileName === null || currentOrder.orderExcelFileName === undefined || currentOrder.orderExcelFileName === 0"
        >

          <i class="bx bx-folder-open align-middle font-size-16"/>
          Otwórz plik z zamówieniem
        </button>
      </div>
      <div style="float: right; margin-right: 2px; z-index: 0;padding-right:unset!important;">
        <button
            v-if="!commonModule.centralInstance"
            type="submit"
            id="open-order-file-btn"
            @click="uploadDataToCentral()"
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
        >

          <i class="bx bx-cloud-upload align-middle font-size-16"/>
          Wyślij dane
        </button>
      </div>
      <div class="row">
        <span>
        <input
            type="checkbox"
            id="hide-items-with-zero-amount"
            v-model="hideItemsWithZeroAmount"
            @change="refreshAllPackageItemsOfOrder"
        />
        <label for="hide-items-with-zero-amount" class="ms-1"
        >Ukryj pozycje z zerową ilością zamówioną</label
        >

        </span>

      </div>

    </div>

    <div class="row">
      <div>
        <b-modal v-model="lastSuppliesDialogVisible"
                 id="last-supplies-for-item-modal"
                 scrollable
                 title="Ostatnie dostawy"
                 title-class="font-18"
                 hide-footer
                 size="xl"
        >
          <div>
            <div class="row">
              <div class="col">
                <div>
                  <span v-html="itemSuppliesTable"> </span>
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <b-modal v-model="massNotificationsDialogVisible"
                 id="mass-add-notifications-to-item-form-modal"
                 scrollable
                 title="Dodawanie uwag do pozycji"
                 title-class="font-18"
                 hide-footer
                 size="xl"
        >
          <div>
            <div class="row">
              <div class="col">
                <div style="width: 100%">
                  <input
                      type="text"
                      id="mass-items-notifications"
                      class="form-control"
                      placeholder="Wpisz uwagi (opcjonalnie)"
                      v-model="itemMassNotifications"
                  />
                  <button
                      type="submit"
                      id="mass-add-notifications-btn"
                      @click="massAddNotificationsToItems()"
                      class="btn btn-outline-success"
                      style="margin-top: 2px"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <b-modal v-model="associatedDocsDialogVisible"
                 id="associated-supplies-docs-for-item-modal"
                 scrollable
                 title="Powiązane dokumenty dostaw"
                 title-class="font-18"
                 hide-footer
                 size="xl"
                 style="z-index:99999!important;"

        >
          <div>
            <div class="row">
              <div class="col">
                <div style="width: 100%; text-align: left">
                  <ScrollableListView
                      :title="currentItemAssociatedDocsTitle"
                      :listContent="currentItemAssociatedDocs"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <b-modal v-model="showItemNotificationsDialogVisible"
                 id="item-notifications-modal"
                 scrollable
                 title="Uwagi do pozycji"
                 title-class="font-18"
                 hide-footer
                 size="xl"
                 style="z-index:99999!important;"
        >
          <div>
            <div class="row">
              <div class="col">

                <ScrollableListView
                    :listContent="itemClicked.notifications"
                    ulStyle="height:200px;text-align:left;"
                />

              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <CommonDataPanel :key="dataPanelData" :data="dataPanelData" :headers="dataPanelHeaders"
                         :maxGridColumns="2"
                         :allowGridItemWidth="true"
                         titleKey="drugstore"
                         @onTriggerAction="runAction($event)"
        />
        <CommonTable2
            :table="tableData"
            rowIdentifier="guid"
            :currentPage="currentPage"
            :totalRows="packagesModule.getPackageItemsTotal"
            :totalPages="Math.ceil(packagesModule.getPackageItemsTotal / 50)"
            :showCheckboxColumn="true"
            :showPaginationTop="true"
            :showPaginationBottom="true"
            :showMassActions="true"
            :multiselect="true"
            :enableRowSelection="true"
            :sortColumn="sortingKey"
            :sortDirection="sortingDirection"
            @onPageChange="handlePageChange"
            @onCheckItem="handleSelection"
            @onMassAction="runMassAction"
            @onItemAction="runAction"
            @onSort="handleSort"
            :key="refreshTable"
        />
      </div>
    </div>

    <hr/>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import ScrollableListView from "@/components/widgets/ScrollableListView.vue";
import dateFormat from "dateformat";
import {log} from "@/state/pinia/log";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {BModal} from "bootstrap-vue-next";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import CommonDataPanel from "@/components/widgets/CommonDataPanel.vue";

export default {
  name: "PackagesManagerItemsList",
  components: {CommonDataPanel, CommonTable2, BModal, ScrollableListView},
  props:{
    orderGuid: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      // Data structure compatible with CommonTable2
      tableData: {},
      refreshTable: false,

      itemSuppliesTable: "<h5>Brak dostaw</h5>",
      packageProductItems: [],
      currentOrderGuid: null,

      currentOrder: {},
      selectedItems: [],
      itemMassNotifications: "",

      sortingDirection: "ASC",
      sortingKey: "id",
      currentPage: 1,

      lastSuppliesDialogVisible: false,
      associatedDocsDialogVisible: false,
      checkSuppliesDateFrom: "2021-11-01",
      hideItemsWithZeroAmount: true,
      massNotificationsDialogVisible: false,
      currentItemAssociatedDocsTitle: "Brak powiązanych dokumentów dostaw dla tej pozycji.",
      currentItemAssociatedDocs: "",
      showItemNotificationsDialogVisible: false,
      itemClicked: {},

      // Definitions matching CommonTable2 style from reference component
      availableHeaders: [
        { text: "Lp.", key: "id", type: "number", width: "50px",style:"text-align:left!important;", sortable: true },
        { text: "Nazwa", key: "nameDisplay", type: "text", sortable: true, width: "300px" },
        { text: "BLOZ", key: "bloz", type: "text", sortable: true, width: "80px" },
        { text: "Ilość", key: "amount", type: "number", width: "70px", sortable: true },
        { text: "Rabat", key: "discount", type: "number", width: "70px", sortable: true },
        {
          text: "Status",
          key: "statusConfig", // Tu trafi dynamiczna konfiguracja przycisku
          type: "button",      // Używamy zmodyfikowanego typu button
          action: "change-status", // Nazwa akcji po kliknięciu
          width: "160px"
        },
        { text: "Akcje", key: "actions", type: "actions", width: "240px" }
      ],

      tableMassActions: [],
      dataPanelData: null,
      dataPanelHeaders: [
        {text: "Data zam.", key: "orderCreationDate", type: "date", isMeta: true, isEpochMillis:true},
        {text: "Symbol zamówienia", key: "orderReference", type: "text", isMeta: true},
        {text: "Nazwa zamówienia", key: "orderName", type: "text", isMeta: true},
        {
          text: "Dostawca",
          key: "supplierName",
          type: "text",
          isMeta: true
        },
        {
          text: "Stan realizacji",
          key: "realisationLevel",
          type: "progress",
          sortable: true,
          width: "600px"
        },



      ]
    };
  },
  computed: {
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {
    // --- TABLE DATA PREPARATION (Matching reference style) ---

    updateTableData() {
      // 1. Prepare Mass Actions based on context
      this.tableMassActions = [];
      if (!this.commonModule.centralInstance) {
        this.tableMassActions = [
          { text: "Otrzymane", icon: "fas fa-check", action: "mass-received", enabled: true, class: "btn btn-success" },
          { text: "Otrzymane (uwagi)", icon: "fas fa-exclamation", action: "mass-received-notes", enabled: true, class: "btn btn-warning" },
          { text: "Nieotrzymane", icon: "fas fa-times", action: "mass-not-received", enabled: true, class: "btn btn-danger" },
          { text: "Wyślij raport", icon: "fas fa-file-export", action: "mass-report", enabled: true, class: "btn btn-info" },
          { text: "Dodaj uwagi", icon: "fas fa-comment", action: "mass-notes", enabled: true, class: "btn btn-primary" }
        ];
      }

      // 2. Prepare Rows
      const transformatedRows = this.packageProductItems
          .filter(item => this.shouldItemBeVisible(item))
          .map(item => {
            const isIgnored = item.ignored;

            // Name formatting (simulated since we rely on text/actions)
            let displayName = item.name;
            if (isIgnored) {
              displayName = "(Zignorowany) " + item.name;
            }

            // --- Construct Row Actions ---
            const rowActions = [];
            const isCentral = this.commonModule.centralInstance;


            let statusConfigObj = {};

            // Czy przycisk aktywny?
            const isDisabled = isIgnored || isCentral;

            if ([0, 3, 5, 8].includes(item.status)) {
              // Stan: Nieotrzymany
              statusConfigObj = {
                text: "Nieotrzymany",
                class: "btn btn-sm btn-danger w-100", // w-100 żeby ładnie wypełnił komórkę
                disabled: isDisabled
              };
            } else if ([1, 2].includes(item.status)) {
              // Stan: Otrzymany
              statusConfigObj = {
                text: "Otrzymany",
                class: "btn btn-sm btn-success w-100",
                disabled: isDisabled
              };
            } else {
              // Stan: Z uwagami
              statusConfigObj = {
                text: "Otrzymany z uwagami",
                class: "btn btn-sm btn-warning w-100",
                disabled: isDisabled
              };
            }

            // B. Notifications Icon
            if (item.notifications && item.notifications.length > 0) {
              rowActions.push({
                icon: "fas fa-comment-dots",
                action: "show-notifications",
                tooltip: "Pokaż uwagi",
                enabled: true,
                class: "btn btn-sm btn-warning text-dark"
              });
            }

            // C. Supplies Icon
            if (!isCentral) {
              rowActions.push({
                icon: "fas fa-cube",
                action: "show-supplies",
                tooltip: "Pokaż ostatnie dostawy",
                enabled: true,
                class: "btn btn-sm btn-info text-white"
              });
            }

            // D. Docs Icon
            rowActions.push({
              icon: "fas fa-list",
              action: "show-docs",
              tooltip: "Powiązane dokumenty",
              enabled: true,
              class: "btn btn-sm btn-info text-white"
            });

            // E. Edit BLOZ (Replaces inline edit)
            if(!isCentral && !isIgnored) {
              rowActions.push({
                icon: "fas fa-pen",
                action: "edit-bloz",
                tooltip: "Edytuj numer BLOZ",
                enabled: true,
                class: "btn btn-sm btn-outline-primary"
              });
            }

            // F. Delete / Ignore Logic
            if (item.localSurplus === true) {
              rowActions.push({
                icon: "fas fa-trash-alt",
                action: "delete-item",
                tooltip: "Usuń pozycję",
                enabled: true,
                class: "btn btn-sm btn-danger"
              });
            } else {
              if (!isIgnored) {
                rowActions.push({
                  icon: "fas fa-ban",
                  action: "ignore-item",
                  tooltip: "Zignoruj pozycję",
                  enabled: true,
                  class: "btn btn-sm btn-secondary"
                });
              } else {
                rowActions.push({
                  icon: "fas fa-check",
                  action: "unignore-item",
                  tooltip: "Przywróć pozycję",
                  enabled: true,
                  class: "btn btn-sm btn-primary"
                });
              }
            }

            return {
              ...item,
              guid: item.guid, // Essential for CommonTable2 rowIdentifier
              nameDisplay: displayName,
              statusConfig: statusConfigObj,
              actions: rowActions,
              "row-class": isIgnored ? "row-disabled" : "" // Styling ignored rows
            };
          });

      // 3. Assign to tableData prop
      this.tableData["headers"] = this.availableHeaders;
      this.tableData["massActions"] = this.tableMassActions;
      this.tableData["data"] = transformatedRows;

      this.refreshTable = !this.refreshTable; // Force re-render if needed
    },


    // --- ACTION HANDLERS (runAction pattern) ---

    runAction(event) {
      const action = event.action.action;
      const itemData = event.itemData; // This comes from CommonTable2 row data
      log.log("Action triggered:", event);
      // We need the index in the original array for some operations
      const index = this.packageProductItems.findIndex(i => i.guid === itemData.guid);

      if (index === -1) {
        console.warn("Item not found in source array", itemData);
        return;
      }

      switch (action) {
        case "change-status":
          this.changeItemStatus(index);
          break;
        case "show-supplies":
          this.getAllSuppliesForBloz(itemData.bloz);
          this.openLastSuppliesDialog();
          break;
        case "show-docs":
          this.openAssociatedDocsDialog(itemData);
          break;
        case "show-notifications":
          this.openNotificationsDialog(itemData);
          break;
        case "edit-bloz":
          this.handleEditBloz(index, itemData.bloz);
          break;
        case "delete-item":
          this.removeItems(itemData.guid, false);
          break;
        case "ignore-item":
        case "unignore-item":
          this.setItemsIgnored(this.packageProductItems[index], false);
          break;
      }
    },

    runMassAction(event) {
      const action = event.action.action;
      // selectedItems are updated via handleSelection before this call

      switch (action) {
        case "mass-received":
          this.massChangeItemsStatus(this.packagesModule.getPackageItemsStatuses.ITEM_FULLY_RECEIVED, true);
          break;
        case "mass-received-notes":
          this.massChangeItemsStatus(this.packagesModule.getPackageItemsStatuses.ITEM_RECEIVED_WITH_NOT_ACCEPTABLE_AMOUNT_AND_ACCEPTABLE_DISCOUNT, true);
          break;
        case "mass-not-received":
          this.massChangeItemsStatus(this.packagesModule.getPackageItemsStatuses.ITEM_NOT_RECEIVED, false);
          break;
        case "mass-report":
          this.sendReportToCentralOffice();
          break;
        case "mass-notes":
          this.openMassNotificationsDialog();
          break;
      }
    },

    handleSelection(payload) {
      // payload.items contains array of GUIDs
      this.selectedItems = payload.items;
    },

    handlePageChange(newPage) {
      this.currentPage = newPage;
      this.refreshAllPackageItemsOfOrder();
    },

    handleSort(key) {
      if (this.sortingKey === key) {
        this.sortingDirection = this.sortingDirection === "ASC" ? "DESC" : "ASC";
      } else {
        this.sortingKey = key;
        this.sortingDirection = "ASC";
      }
      this.sortBy(key);
    },

    // --- LOGIKA BIZNESOWA (Przeniesiona z oryginału) ---

    // Nowa implementacja edycji BLOZ (zamiast inline input, popup)
    async handleEditBloz(index, currentBloz) {
      const result = await Swal.fire({
        title: 'Edytuj numer BLOZ',
        input: 'text',
        inputValue: currentBloz,
        showCancelButton: true,
        confirmButtonText: 'Zapisz',
        cancelButtonText: 'Anuluj',
        inputValidator: (value) => {
          if (!value) {
            return 'Musisz wpisać numer BLOZ!';
          }
        }
      });

      if (result.isConfirmed) {
        this.updateItemsBloz(index, result.value);
      }
    },

    sortBy(sortingKeyValue) {
      this.packagesModule.setPackageItems([]);
      // Reset page when sorting changes
      // this.currentPage = 1;
      var requestPayload = {
        currentPage: this.currentPage,
        sortingKey: sortingKeyValue,
        sortingDirection: this.sortingDirection,
        filterSettingsObject: {orderGuid: this.currentOrderGuid},
      };
      this.packagesModule.httpGetPackageItemsByOrderGuidPaging(requestPayload);
    },

    refreshPackageItemsList() {
      this.currentOrderGuid  = this.fetchCurrentOrderGuid();
      this.packagesModule.setPackageItems([]);
      var requestPayload = {
        currentPage: this.currentPage,
        sortingKey: this.sortingKey,
        sortingDirection: this.sortingDirection,
        filterSettingsObject: {orderGuid: this.currentOrderGuid},
      };
      return this.packagesModule.httpGetPackageItemsByOrderGuidPaging(requestPayload)
    },

    refreshAllPackageItemsOfOrder() {
      return this.refreshPackageItemsList().then(() => {
        this.packageProductItems = JSON.parse(JSON.stringify(this.packagesModule.getPackageItems));
        this.updateTableData(); // IMPORTANT: Refresh CommonTable2 data
      });
    },

    // --- Existing logic methods kept as is ---

    getFormattedSentDate() {
      var dateTimeString = this.getLastMailReportSendDate;
      if (dateTimeString.length >= 3) {
        return (
            dateTimeString[0] + "." + dateTimeString[1] + "." + dateTimeString[2]
        );
      }
      return "";
    },
    removeItems(itemGuidToRemove, removeAllChecked) {
      Swal.fire({
        title: "Czy na pewno chcesz usunąć te pozycje?",
        text: "Proces usuwania jest nieodwracalny.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
        showCancelButton: true,
        cancelButtonText: 'Nie',
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Tak, usuń!"
      }).then((result) => {
        if (result.isConfirmed) {
          var itemsGuidsToRemove = [itemGuidToRemove];
          if (removeAllChecked === true) {
            itemsGuidsToRemove = this.selectedItems;
          }

          var requestPayload = {
            itemsGuids: itemsGuidsToRemove,
          };
          this.packagesModule.httpRemovePackageItemsForLocalSurplus(requestPayload).then(() => {
            this.refreshPackageItemsList();
          });
        }
      });
    },
    fetchCurrentOrderGuid(){
      if(this.orderGuid && this.orderGuid.length > 0) {
        return this.orderGuid;
      } else {
        return this.$route.query.orderGuid;
      }
    },
    getOrderByGuid(currentItemsOrderGuid) {
      var payload = {
        orderGuid: currentItemsOrderGuid,
      };
      this.packagesModule.httpGetOrderByGuid(payload)
          .then((response) => {
            if(response.status === 200) {
              this.currentOrder = response.data.payload;
              this.dataPanelData = this.currentOrder;
              const drugstore = this.commonModule.getDrugstoresNameMap[this.currentOrder.drugstoreClientId] || `Nieznana apteka`;
              this.dataPanelData["drugstore"] = ` [${this.currentOrder.drugstoreClientId}] ${drugstore}`;
            }
            return apiRequestsHelper.handleResponseWithDialogs(response, false);

          }).catch((error) => {
        return apiRequestsHelper.catchResponseError(error, "httpGetOrderByGuid")
      });
    },
    openNotificationsDialog(item) {
      this.itemClicked = item;
      this.showItemNotificationsDialogVisible = true;
    },

    massChangeItemsStatus(newStatus, setReceived) {
      var changeStatusRequest = {
        itemsIds: this.selectedItems,
        itemStatus: newStatus,
        isReceived: setReceived,
      };
      this.packagesModule.httpMassChangeSingleItemStatus(changeStatusRequest);
      // Optimistic update locally
      for (var i = 0; i < this.packageProductItems.length; i++) {
        if (this.selectedItems.includes(this.packageProductItems[i].guid)) {
          this.packageProductItems[i].status = newStatus;
        }
      }
      this.updateTableData(); // Update UI
    },
    massAddNotificationsToItems() {
      var notificationsRequest = {
        itemsGuids: this.selectedItems,
        notification: this.itemMassNotifications,
        override: false,
      };
      this.packagesModule.httpAddNotificationsToSingleItems(notificationsRequest)
          .then((response) => {
            if (response && response.status === 200) {
              var listOfUpdatedItems = response.data.payload;
              for (var i = 0; i < listOfUpdatedItems.length; i++) {
                for (var j = 0; j < this.packageProductItems.length; j++) {
                  if (listOfUpdatedItems[i].guid == this.packageProductItems[j].guid) {
                    this.packageProductItems[j].notifications =
                        listOfUpdatedItems[i].notifications;
                  }
                }
              }
              this.updateTableData(); // Update UI
            }
            this.closeMassNotificationsDialog();
          })

    },
    openAssociatedDocsDialog(item) {
      this.currentItemAssociatedDocsTitle =
          "Powiązane numery dostaw dla pozycji: " + item.name;
      this.currentItemAssociatedDocs = item.associatedSupplyReferences;
      this.associatedDocsDialogVisible = true;
    },
    closeAssociatedDocsDialog() {
      this.currentItemAssociatedDocs = "";
      this.currentItemAssociatedDocsTitle =
          "Brak powiązanych dokumentów dostaw dla tej pozycji.";
      this.associatedDocsDialogVisible = false;
    },
    openLastSuppliesDialog() {
      this.lastSuppliesDialogVisible = true;
    },
    closeLastSuppliesDialog() {
      this.lastSuppliesDialogVisible = false;
    },
    openMassNotificationsDialog() {
      this.massNotificationsDialogVisible = true;
    },
    closeMassNotificationsDialog() {
      this.massNotificationsDialogVisible = false;
    },
    sendReportToCentralOffice() {
      var payload = {
        itemsGuids: this.selectedItems,
        orderGuid: this.currentOrder.guid,
      };

      this.packagesModule.httpSendReportForItems(payload)
    },
    resetOrderDetails() {
      Swal.fire({
        title: "Uwaga!",
        text: "Proces resetowania spowoduje usunięcie dotychczasowych statusów i notatek dotyczących tego zamówienia. Czy kontynuować?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak, resetuj!"
      }).then((result) => {
        if (result.isConfirmed) {
          log.log("Resetting order " + this.currentOrderGuid);
          this.packagesModule.httpResetPackageOrder({orderGuid: this.currentOrderGuid}).then(() => {
            this.lazyloaderModule.setDisplayLazyLoader(false);
            this.lazyloaderModule.setProgressBarMessage("");
            this.refreshAllPackageItemsOfOrder();
          })
        }
      });
    },
    uploadDataToCentral(){
      this.packagesModule.httpUploadPackageOrderDataToCentralApp([this.currentOrderGuid])
    },
    checkOrderSupplies() {
      var checkSuppliesRequest = {
        ordersGuids: [this.currentOrderGuid],
      };
      this.packagesModule.httpCheckSuppliesForOrder(checkSuppliesRequest).then(()=>{
        this.refreshAllPackageItemsOfOrder();
      });
    },
    openOrderExcelFile() {
      var requestPayload = {
        orderGuid: this.currentOrderGuid,
      };
      log.log("Opening order excel file for order: " + this.currentOrderGuid)
      this.packagesModule.httpOpenOrderExcelFile(requestPayload);
    },
    shouldItemBeVisible(item) {
      if (this.hideItemsWithZeroAmount) {
        if (item.amount > 0) {
          return true;
        } else {
          return false;
        }
      }

      return true;
    },
    changeItemStatus(itemIndex) {
      let itemsGuidsToUpdate = [];
      let changeStatusRequest = {};

      if (
          this.packageProductItems[itemIndex].status == 0 ||
          this.packageProductItems[itemIndex].status == 8
      ) {
        this.packageProductItems[itemIndex].status = 1;
        itemsGuidsToUpdate = [];
        itemsGuidsToUpdate.push(this.packageProductItems[itemIndex].guid);

        changeStatusRequest = {
          itemsGuids: itemsGuidsToUpdate,
          itemStatus: this.packagesModule.getPackageItemsStatuses.ITEM_FULLY_RECEIVED,
          isReceived: true,
        };
        this.packagesModule.httpChangePackageItemStatus(changeStatusRequest);
      } else if (
          this.packageProductItems[itemIndex].status == 1 ||
          this.packageProductItems[itemIndex].status == 2
      ) {
        this.packageProductItems[itemIndex].status = 7;
        itemsGuidsToUpdate = [];
        itemsGuidsToUpdate.push(this.packageProductItems[itemIndex].guid);
        changeStatusRequest = {
          itemsGuids: itemsGuidsToUpdate,
          itemStatus:
          this.packagesModule.getPackageItemsStatuses
              .ITEM_CHECKED_MANUALLY_WITH_MANUAL_NOTIFICATIONS,
          isReceived: true,
        };
        this.packagesModule.httpChangePackageItemStatus(changeStatusRequest);
      } else if (
          this.packageProductItems[itemIndex].status == 3 ||
          this.packageProductItems[itemIndex].status == 4 ||
          this.packageProductItems[itemIndex].status == 5 ||
          this.packageProductItems[itemIndex].status == 6 ||
          this.packageProductItems[itemIndex].status == 7 ||
          this.packageProductItems[itemIndex].status == 9
      ) {
        this.packageProductItems[itemIndex].status = 0;
        itemsGuidsToUpdate = [];
        itemsGuidsToUpdate.push(this.packageProductItems[itemIndex].guid);
        changeStatusRequest = {
          itemsGuids: itemsGuidsToUpdate,
          itemStatus: this.packagesModule.getPackageItemsStatuses.ITEM_NOT_RECEIVED,
          isReceived: false,
        };
        this.packagesModule.httpChangePackageItemStatus(changeStatusRequest);
      }
      this.updateTableData(); // Update UI
    },
    setItemsIgnored(itemToIgnore, ignoreAllChecked){
      var itemsToIgnore = [];
      if(ignoreAllChecked) {
        itemsToIgnore = this.selectedItems;
      }else{
        itemsToIgnore.push(itemToIgnore.guid);
      }
      itemToIgnore.ignored = !itemToIgnore.ignored;

      var payload = {
        itemsGuids: itemsToIgnore,
        ignored: itemToIgnore.ignored,
      };

      this.packagesModule.httpChangePackageItemIgnoredStatus(payload)
      this.updateTableData(); // Update UI
    },
    getAllSuppliesForBloz(bloz) {
      var payload = {
        blozNumber: bloz,
      };
      this.packagesModule.httpGetSuppliesForPackageItem(payload);
    },
    updateItemsBloz(index, bloz) {
      var payload = {
        blozNumber: bloz,
        itemGuid: this.packageProductItems[index].guid,
      };
      this.packagesModule.httpUpdateItemsBloz(payload);
      // Odśwież widok lokalnie
      this.packageProductItems[index].bloz = bloz;
      this.updateTableData(); // Update UI
    },
    getFormattedOrderCreationDate(sourceValue,isEpochMilliseconds) {
      if(!isEpochMilliseconds){
        return sourceValue;
      }

      if(!sourceValue || sourceValue == 0){
        return "Brak daty";
      }

      var date = new Date(sourceValue); // The 0 sets the date to the epoch
      return dateFormat(date, "dd.mm.yyyy");
    }
  },

  watch: {
    packageItemSuppliesTable: {
      handler(newVal) {
        log.log("Last supplies table update:" + newVal);
        this.itemSuppliesTable = newVal
      },
      deep: true,
    },
    currentPage: {
      handler() {
        this.refreshAllPackageItemsOfOrder();
      },
      deep: true,
    },

  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {

      this.commonModule.httpGetWorkingProfile().then(() => {
        var date = new Date();
        this.checkSuppliesDateFrom =  dateFormat(date, "yyyy-mm-dd");
        this.currentOrderGuid = this.fetchCurrentOrderGuid();
        this.getOrderByGuid(this.currentOrderGuid);
        this.refreshAllPackageItemsOfOrder().then(() => {
          const seenStatusRequest = {
            orderGuid: this.currentOrderGuid,
          };
          this.packagesModule.httpCheckOrderChangesAsSeen(seenStatusRequest);
        })
      });

    });



  },
};
</script>

<style scoped>
.package-order-header-section {
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>